import { CurrencySetting, Point } from "../../type";

export type AnimationPoint = {
  x: number;
  y: number;
  isIceBreak: boolean;
  isDropdownPoint: boolean;
  groupId: number;
  endId: number;
  win: number;
  beforeWin?: number;
};

export type CleopatrasTreasureGameData = {
  bombCount: number;
  animationPoints?: AnimationPoint[];
  triggeredFeatureSymbolId: FeatureSymbols;
  triggeredFeaturePoint?: Point;
  candyBaySymbolIds?: number[];
  rocketDirection: "None" | "Horizontal" | "Vertical";
  multiplys: number[][];
};

export enum Symbols {
  Coin5 = 201,
  Coin6 = 202,
  Coin7 = 203,
  Coin8 = 204,

  Coin1 = 101,
  Coin2 = 102,
  Coin3 = 103,
  Coin4 = 104,

  Scatter = 25,
}

export enum FeatureSymbols {
  None = 0,
  CleopatrasTreasure = 8,
}

export type Rule = {
  buyFreeSpinRate: number;
  payouts: { [k: string]: number };
  givenFreeSpin: { [k: string]: number };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: number };
  buyFreeSpinRate: number;
};
